import React from 'react'
import Select from 'react-select'
import css from './style.css'

const SelectForm = (props) => (
  <div className={css.selectFormRoot}>
    <Select {...props} clearable={!!props.value} />
  </div>
)

export default SelectForm



// WEBPACK FOOTER //
// ./src/components/select-form/index.js